import axios from "axios";

function getImagenology(objData) {
	return new Promise((resolve, reject) => {
		let port = ""
		if (process.env.ROOT_API.includes("viewmedonline"))
			port = ":3040"
		axios.post(process.env.ROOT_API  + "/medical/objects", {
			user: objData.user,
			type: objData.type,
			size: objData.size,
			page: objData.page
		}, {
				headers: {
					'Authorization': objData.token
				}
			}).then(result => {
				resolve(result.data.documents[0])
			}).catch(error => {
				reject(error.response.data.message)
			})
	})
}

function listImagenology(objData) {
	return new Promise((resolve, reject) => {
		let port = ""
		if (process.env.ROOT_API.includes("viewmedonline"))
			port = ":3022"
		axios.post(process.env.ROOT_API  + "/imagings/list", objData.body, {
			headers: {
				'Authorization': objData.token
			}
		}).then(result => {
			resolve(result.data.documents)
		}).catch(error => {
			reject(error.response.data.message)
		})
	})
}

function insertAtributte(objData) {
	return new Promise((resolve, reject) => {
		let port = ""
		if (process.env.ROOT_API.includes("viewmedonline"))
			port = ":3025"
		axios.post(process.env.ROOT_API  + "/attributes", objData.body, {
			headers: {
				'Authorization': objData.token
			}
		}).then(result => {
			resolve(result.data.documents[0])
		}).catch(error => {
			reject(error.response.data.message)
		})
	})
}

function insertNotification(objData) {

	return new Promise((resolve, reject) => {
		let port = ""
		if (process.env.ROOT_API.includes("viewmedonline"))
			port = ":3046"
		axios.post(process.env.ROOT_API  + "/notifications/insert", {
			sender: objData.sender,
			receiver: objData.receiver,
			message: objData.message
		}, {
				headers: {
					Authorization: objData.token
				}
			}).then(result => {

				resolve(result.data.documents)
			}).catch(error => {

				reject(error.response.message)
			})
	})
}

function downloadImage(objData) {
	return new Promise((resolve, reject) => {
		let port = ""
		if (process.env.ROOT_API.includes("viewmedonline"))
			port = ":3045"
		axios.post(process.env.ROOT_API  + "/imagings/download", {
			bucket: "dicom_storage",
			files: objData.files,
			format: objData.format,
			viewer: objData.viewer
		}, {
				headers: {
					Authorization: objData.token
				},
				responseType: 'blob'
			}).then(result => {
				resolve(result.data)
			}).catch(error => {
				reject(error.response.data.message)
			})
	})
}

function validateImaging(objData) {
	return new Promise((resolve, reject) => {
		let port = ""
		if (process.env.ROOT_API.includes("viewmedonline"))
			port = ":3047"
		axios.post(process.env.ROOT_API  + "/imagings/validate", {
			bucket: "dicom_storage",
			path: objData.path
		}, {
				headers: {
					Authorization: objData.token
				}
			}).then(result => {
				resolve(result.data.documents)
			}).catch(error => {
				reject(error.response.message)
			})
	})
}

// function filterImagins(objData) {
// 	return new Promise((resolve, reject) => {
// 		let port = ""
// 		if (process.env.ROOT_API.includes("viewmedonline"))
// 			port = ":3021"
// 		let img = axios.create({
// 			url: process.env.ROOT_API  + "/imagings/query",
// 			method: 'PUT',
// 			headers: {
// 				Authorization: objData.token
// 			},
// 			data: objData.body
// 		});
// 		img.interceptors.response.use((response) => {
// 			if (response.data.documents[0].total > 0) {
// 				return response.data.documents[0];
// 			} else {
// 				return 0;
// 			}
// 		}, (error) => {
// 			return reject(error)
// 		})
// 		img().then(result => {
// 			resolve(result)
// 		});
// 	})
// }

function getFileImaging(objData) {
	return new Promise((resolve, reject) => {
		try {
			let port = ""
			if (process.env.ROOT_API.includes("viewmedonline"))
				port = ":3027"
			axios.get(process.env.ROOT_API  + "/get_file/" + objData.fileId, {
				headers: {
					Authorization: objData.token
				}, responseType: 'arraybuffer',
			}).then(result => {
				// console.log(result)
				resolve(result.data)
			}).catch(error => {
				reject(error.response.data.message)
			})
		} catch (err) {
			console.log('Err in getFile: ', err)
		}
	})
}

function imagingUpdate(objData) {
	return new Promise((resolve, reject) => {
		let port = ""
		if (process.env.ROOT_API.includes("viewmedonline"))
			port = ":3020"
		axios.put(process.env.ROOT_API  + "/imagings/update/" + objData.id, objData.body, {
			headers: {
				Authorization: objData.token
			}
		}).then(result => {
			resolve(result.data.documents)
		}).catch(error => {
			reject(error.response.data.message)
		})
	})
}

function showImaging(objData) {
	// return new Promise((resolve, reject) => {
  //   try {
  //     let port = "";
  //     if (process.env.ROOT_API.includes("viewmedonline")) port = ":3027";
  //     axios
  //       .get("http://localhost:3000/get_file/" +  objData.fileId, {
  //         responseType: "blob",
  //         headers: {
  //           "content-type": "multipart/form-data",
  //           Authorization: objData.token
  //         }
  //       })
  //       .then(result => {
  //         resolve(result);
  //       })
  //       .catch(error => {
  //         reject(error);
  //       });
  //   } catch (err) {
  //     console.log("err in Get Image: ", err);
  //   }
  // });
	
	return new Promise((resolve, reject) => {
		let port = ""
		if (process.env.ROOT_API.includes("viewmedonline"))
			port = ":3027"
		let xhr = new XMLHttpRequest();
		xhr.open("GET", process.env.ROOT_API  + "/get_file/" + objData.fileId)
		xhr.setRequestHeader("Authorization", objData.token)
		xhr.responseType = "arraybuffer"
		xhr.onload = function (e) {
			let arraybufferView = new Uint8Array(this.response);
			let blob = new Blob([arraybufferView], { type: "image/png" });
			let urlCreator = window.URL || window.webkitURL;
			let imageUrl = urlCreator.createObjectURL(blob);
			resolve(imageUrl)
		}
		xhr.send()
	})
}

function tableDocuments(objData) {
	return new Promise((resolve, reject) => {
		let port = ""
		if (process.env.ROOT_API.includes("viewmedonline"))
			port = ":3049"
		axios.get(process.env.ROOT_API  + "/attachment/imaging/" + objData.id, {
			headers: {
				Authorization: objData.token
			}
		}).then(result => {
			resolve(result.data.documents)
		}).catch(error => {
			reject(error.response.data.message)
		})
	})
}

function removeDocuments(objData) {
	return new Promise((resolve, reject) => {
		let port = ""
		if (process.env.ROOT_API.includes("viewmedonline"))
			port = ":3050"
		axios.put(process.env.ROOT_API  + "/remove/attachment/imaging/" + objData.idImaging, objData.body, {
			headers: {
				Authorization: objData.token
			}
		}).then(result => {
			resolve('ok')
		}).catch(error => {
			reject(error.response.data.message)
		})
	})
}

function listImagingDisplay(objData) {
	return new Promise((resolve, reject) => {
		let port = ""
		if (process.env.ROOT_API.includes("viewmedonline"))
			port = ":3051"
		axios.post(process.env.ROOT_API  + "/display/list", objData.body, {
			headers: {
				Authorization: objData.token
			}
		}).then(result => {
			resolve(result.data.documents[0].list)
		}).catch(error => {
			reject(error.response.data.message)
		})
	})
}

function sendMail(objData) {
	return new Promise((resolve, reject) => {
		let port = ""
		if (process.env.ROOT_API.includes("viewmedonline"))
			port = ":3029"
		axios.post(process.env.ROOT_API  + "/send_mail", objData.body, {
			headers: {
				Authorization: objData.token
			}
		}).then(result => {
			resolve(result.data.documents[0])
		}).catch(error => {
			reject(error.response.data.message)
		})
	})
}

function atributeUpdate(objData) {
	return new Promise((resolve, reject) => {
		let port = ""
		if (process.env.ROOT_API.includes("viewmedonline"))
			port = ":3059"
		axios.put(process.env.ROOT_API  + "/attributes/" + objData.email + '/' + objData.id, objData.body, {
			headers: {
				Authorization: objData.token
			}
		}).then(result => {
			resolve(result.data.documents[0])
		}).catch(error => {
			reject(error.response.data.message)
		})
	})
}

function imagingQuery(objData) {
	return new Promise((resolve, reject) => {
		let port = ""
		if (process.env.ROOT_API.includes("viewmedonline"))
			port = ":3021"
		axios.post(process.env.ROOT_API  + "/imagings/query", objData, {
			headers: {
				Authorization: objData.token
			}
		}).then(result => {
			resolve(result.data.documents[0])
		}).catch(error => {
			reject(error.response.data.message)
		})
	})
}

//shared imaging services
function sharedImagingQuery(objData) {
	return new Promise((resolve, reject) => {
		let port = ""
		if (process.env.ROOT_API.includes("viewmedonline"))
			port = ":3104"
		axios.post(process.env.ROOT_API  + "/imagings/shared/query", objData.body, {
			headers: {
				Authorization: objData.token
			}
		}).then(result => {
			resolve(result.data.documents)
		}).catch(error => {
			reject(error.response.data.message)
		})
	})
}

function sharedImagingInsert(objData) {
	return new Promise((resolve, reject) => {
		let port = ""
		if (process.env.ROOT_API.includes("viewmedonline"))
			port = ":3102"
		axios.post(process.env.ROOT_API  + "/imagings/shared/insert", objData.body, {
			headers: {
				Authorization: objData.token
			}
		}).then(result => {
			resolve(result.data.documents)
		}).catch(error => {
			reject(error.response.data.message)
		})
	})
}

//permission imaging services
function permissionImagingQuery(objData) {
	return new Promise((resolve, reject) => {
		let port = ""
		if (process.env.ROOT_API.includes("viewmedonline"))
			port = ":3108"
		axios.get(process.env.ROOT_API  + "/contacts/query/"+objData.body.sender+"/"+objData.body.receiver, {
			headers: {
				Authorization: objData.token
			}
		}).then(result => {
			resolve(result.data.documents)
		}).catch(error => {
			reject(error.response.data.message)
		})
	})
}

function permissionImagingInsert(objData) {
	return new Promise((resolve, reject) => {
		let port = ""
		if (process.env.ROOT_API.includes("viewmedonline"))
			port = ":3106"
		axios.post(process.env.ROOT_API  + "/imagings/permission/insert", objData, {
			headers: {
				Authorization: objData.token
			}
		}).then(result => {
			resolve(result.data.documents)
		}).catch(error => {
			reject(error.response.data.message)
		})
	})
}

function permissionImagingUpdate(objData) {
	return new Promise((resolve, reject) => {
		let port = ""
		if (process.env.ROOT_API.includes("viewmedonline"))
			port = ":3107"
		axios.put(process.env.ROOT_API  + "/imagings/permission/update/" + objData.idPermision, objData.body, {
			headers: {
				Authorization: objData.token
			}
		}).then(result => {
			resolve(result.data.documents)
		}).catch(error => {
			reject(error.response.data.message)
		})
	})
}

function permissionImagingDelete(objData) {
	return new Promise((resolve, reject) => {
		let port = ""
		if (process.env.ROOT_API.includes("viewmedonline"))
			port = ":3109"
		axios.delete(process.env.ROOT_API  + "/imagings/permission/delete/" + objData.idPermision, objData.body, {
			headers: {
				Authorization: objData.token
			}
		}).then(result => {
			resolve(result.data.documents)
		}).catch(error => {
			reject(error.response.data.message)
		})
	})
}

function medicalReoportPdf(objData) {
	return new Promise((resolve, reject) => {
		try {
			axios.get(process.env.ROOT_API  + '/medical/report/pdf/'+objData.id, {
				headers: {
					Authorization: objData.token
				},
				responseType: 'blob'
			}).then(result => {
				resolve(result.data)
			}).catch(error => {
				reject(error.response)
			})
		} catch (err) {
			console.log('Err in getFile: ', err)
		}
	})
}

function downloadSoftware(objData){
	return new Promise((resolve, reject) => {
		let port = ""
		if (process.env.ROOT_API.includes("viewmedonline"))
			port = ":3109"
		axios.get(process.env.ROOT_API  + "/app/download/lost/" + objData.personId, {
			headers: {
				Authorization: objData.token,
			},
			responseType: 'blob'
		}).then(result => {
			resolve(result.data)
		}).catch(error => {
			reject(error.response.data.message)
		})
	})
}

export {
	getImagenology,
	listImagenology,
	insertAtributte,
	insertNotification,
	downloadImage,
	validateImaging,
	filterImagins,
	getFileImaging,
	imagingUpdate,
	showImaging,
	tableDocuments,
	removeDocuments,
	listImagingDisplay,
	sendMail,
	atributeUpdate,
	imagingQuery,
	permissionImagingDelete,
	permissionImagingUpdate,
	permissionImagingInsert,
	permissionImagingQuery,
	sharedImagingQuery,
	sharedImagingInsert,
	medicalReoportPdf,
	downloadSoftware
}



// WEBPACK FOOTER //
// ./src/components/imagenology/imagenologySer.js